import React from 'react';
import './Contact.css'; 
import EmailIcon from './../../images/icons8-neuer-beitrag-100.webp'
import PhoneIcon from './../../images/icons8-telefon-100.webp'
import ClockIcon from './../../images/icons8-uhr-100.webp'
import MarkerIcon from './../../images/icons8-marker-100.webp'
const ContactBoxes = () => (
  <div className="contact-boxes">
    {[
      {
        img: EmailIcon,
        title: 'E-MAIL ADRESSE',
        text: 'elektro_thome@yahoo.de',
      },
      {
        img: PhoneIcon,
        title: 'TELEFON NUMMER',
        text: '+49 6887 894429',
      },
      {
        img: ClockIcon,
        title: 'GESCHÄFTSZEITEN',
        text: 'Mo. - Fr.: 08:00 - 17:00 Uhr',
      },
      {
        img: MarkerIcon,
        title: 'STANDORT',
        text: 'Grübchenstraße 48, 66839 Schmelz',
      },
    ].map((box, index) => (
      <div className="container-box" key={index}>
        <div className="box-img">
          <img src={box.img} alt={box.title} />
        </div>
        <div className="box-text">
          <h1>{box.title}</h1>
          <p>{box.text}</p>
        </div>
      </div>
    ))}
  </div>
);

export default ContactBoxes;
